// extracted by mini-css-extract-plugin
module.exports = {"input":"fromInput_input_30dn2","textright":"fromInput_textright_1f4ON"};